var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQueenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2012.4 2160c0-40.5-0.17969-76.68-0.32422-109.22-1.2227-252.04-1.332-277.13 87.59-376.78h-599.33c88.957 99.684 88.812 124.74 87.59 376.78-0.14453 32.543-0.32422 68.723-0.32422 109.22 0 364.29-185.18 563.33-216.11 594h857.02c-30.922-30.672-216.11-229.71-216.11-594z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1360.8 2790h878.4v72h-878.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1586.8 1386c-7.8477 96.012-77.617 107.71-78.406 108h584.71c-8.4961-1.5469-72.434-16.273-79.922-108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2157.4 1638c10.512-15.086 17.027-33.66 17.027-54s-6.4805-38.914-16.812-54h-714.99c-10.516 15.086-16.992 33.66-16.992 54s6.5156 38.914 17.027 54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2430.8 3294h-1261.5c-21.527 22.895-35.242 54.613-35.242 90 0 69.48 51.695 126 115.2 126h1101.6c63.539 0 115.2-56.52 115.2-126 0-35.387-13.715-67.105-35.242-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1587.6 1260v90h424.8l-0.003906-90c0-108.57 92.914-240.23 93.852-241.52l38.23-53.676-210.24 93.457-134.24-149.19-134.24 149.15-210.35-93.492 38.34 53.711c0.93359 1.3359 93.852 132.8 93.852 241.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1230.2 3258h1139.7c2.7734-24.012 11.41-32.867 22.68-44.062 18.289-18.145 41.078-40.68 41.078-117.94 0-88.453-77.762-134.21-134.57-167.62-16.812-9.8984-34.848-20.555-46.691-30.383h-904.68c-11.844 9.793-29.879 20.484-46.691 30.383-56.812 33.41-134.57 79.164-134.57 167.62 0 77.258 22.789 99.793 41.074 117.94 11.309 11.195 19.91 20.051 22.719 44.062z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.5 1014.7 76.43-33.984c-45-67.066-130.54-113.36-211.71-116.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1791.8 864.39c-81.215 2.9531-166.75 49.246-211.75 116.35l76.43 33.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1908 849.46v-21.457c0-59.688-48.312-108-108-108s-108 48.312-108 108v21.457c35.062-13.754 72.07-21.457 108-21.457s72.938 7.7031 108 21.457z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueenIcon);
export default __webpack_public_path__ + "static/media/queenIcon.478ef3d4d8552274f97e63dd958eb8e0.svg";
export { ForwardRef as ReactComponent };